import { Role } from '../enum';
import { AppLink } from '../enum/link.enum';
import { LinkType } from '../models/link.model';

export const APP_LINKS: { [key in AppLink]: LinkType } = {
  [AppLink.NetworkInfrastructureMap]: {
    name: 'Network Infrastructure Map',
    link: (cfg) => cfg.networkInfrastructureMapUrl,
    requiredRoles: [
      Role.IndependentAuditor,
      Role.FullAdmin,
      Role.RestrictedAdmin,
      Role.RSP,
    ],
    showInMenu: true,
  },
  [AppLink.NetworkInventoryGateway]: {
      name: 'Network Inventory Gateway',
      link: (cfg) => cfg.networkInventoryGatewayMapUrl,
      requiredRoles: [
        Role.DECC,
        Role.IndependentAuditor,
        Role.FullAdmin,
        Role.RestrictedAdmin,
        Role.User,
      ],
      showInMenu: true,
    },
};
